<template>
    <div id="chat-popup"  v-if="showChatPopup">
               <div  id="dialogContent" class="chatbot-main" v-bind:class="{'isMinized':minimiseValue,'isDesktop': !isMobileLayout}" :style="{'max-height': iframeMaxHeight}">
            <iframe scrolling="no" id="chatIframe" @load="sendMessageToIframe" :src="getTgptIframeUrl" title="chatbot-iframe" ref="iframeRef" allow="clipboard-write"></iframe>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions,mapMutations } from "vuex";
import debounce from "lodash.debounce";
import CartService from "../../classes/customer/CartService.js";
import Cookies from "js-cookie";


export default {
    components:{
        CartService
    },
    name: "AIChatPopupModal",
    data() {
        return {
            bannerHeight: 0, 
            iframeMessages: [],
            isMobileBreakPoint: false,
            width: window.innerWidth,
            mobileCutoff: "desktop",
            isMobileMax:false,
            cartQuantity: 0,
            tgptIframeUrl:tgptIframeUrl

        }
    },
    computed:  {
        ...mapState("tgpt",['showChatPopup','inputSearchQuery','minimiseValue','isIframeInitialLoad','sessionID','isQueryType','screenName']),
        iframeMaxHeight() {
            let returnValue = '85dvh'
            if(this.isMobileLayout && !this.isMobileMax) {
                returnValue = `calc(92.5dvh - ${this.bannerHeight}px)`;
            }
            if(this.minimiseValue) {
                returnValue = '48px'
            }
            if(this.isMobileMax && this.isIframeInitialLoad )  {
                returnValue = '50dvh'
            }
            return returnValue
        },
        isProductPage() {
            let returnValue = false
            const pdpPage = document.getElementById('pages-product-content')
            if(pdpPage) {
                returnValue = true
            }
            return returnValue
        },
        isSearchPage() {
            let returnValue = false
            const isSearch = document.getElementById('pages-search-search-content')
            if(isSearch) {
                returnValue = true
            }
            return returnValue

        },
        cutoffPixels() {
            return this.cutoffToPixels(this.mobileCutoff);
        },
        isMobileLayout() {
            return !(this.width >= this.cutoffPixels);
        },
        getTgptIframeUrl() {
            const baseUrl = this.tgptIframeUrl || '';
            return `${baseUrl}?cartQuantity=0`;
        }
    },
    methods: {
        ...mapActions("tgpt",[
             "closeIframe",
             "checkSessionCookie",
             "updateInputSearchQuery",
             "setIframeRef",
             "setIframeLoaded",
             "setIframeRef",
             "updateMiniseAndMaximiseValue",
             "openIframe",
             "open",
             "close",
             "updateSessionId",
             "handleMiniseAndMaxiseEvent"
        ]),
        ...mapMutations("tgpt",[
            "SET_MINIMISE"
        ]),
        ...mapMutations("tgpt", ["UPDATE_MINIMISE_AND_Maxmise"]),

        closeModalIframe() {
            this.closeIframe()
            this.updateInputSearchQuery()
            this.setIframeLoaded(false);

        },
        sendMessageToIframe: debounce(function() {
            const iframeRefs = this.$refs.iframeRef
            if (iframeRefs && iframeRefs.contentWindow) {
                this.setIframeRef(iframeRefs);
                this.setIframeLoaded(true);
                const iframeWindow = iframeRefs.contentWindow;
                let message =  this.inputSearchQuery || ''; 
                const cookies = document.cookie; 
                const allCookies = cookies.split(';').reduce((acc, cookie) => {
                const [key, value] = cookie.split('=').map(s => s.trim());
                acc[key] = value;
                return acc;
                }, {});
                const quantity = window.sessionStorage.getItem("cartQuantity");
                if (quantity) {
                    this.cartQuantity = quantity;
                }
                let screenName = document.title;
                iframeRefs.contentWindow.postMessage({
                    type: 'set-cookies',
                    message:message,
                    cookies: allCookies,
                    isProductPage:this.isProductPage,
                    isSearchPage:this.isSearchPage,
                    productsSkus:Cookies.get('skuParams') || '',
                    sessionId : this.sessionID,
                    minimiseValue: this.minimiseValue === true ? false : true,
                    cartQuantity: this.cartQuantity || 0,
                    isQueryType: this.isQueryType,
                    screenName: screenName
                }, this.tgptIframeUrl);
            }
        }, 500),
        handleIframeMessage(event) {
            let context = this
            if (event.data.type === 'FROM_IFRAME') {
                context.iframeMessages.push(event.data.message)
            }
            if (event.data.type === 'CLOSE_DIALOG') {
                context.closeModalIframe();
            }
            if (event.data.type === 'MIMIZE_MAXMISE') {
                    context.updateMiniseAndMaximiseValue()
                    context.$forceUpdate()
            }
            if (event.data.type === 'REDIRECT_URL') {
                const url = event.data.url;
                window.location.href = url;
            }
            if (event.data.type === 'ADDTOCART_CLICK') {
                const productId = event.data?.productId;
                const productName = event.data?.productName | '';
                    if (productId) {
                        this.cartService.addProduct({id: productId, name: productName, quantity: 1, frequency: 0, usePoints: false})
                        .then(response => {
                            // setting up the cart quantity to session storage
                            this.cartQuantity = response.lines.reduce((acc, line) => acc + line.quantity, 0);
                            this.$store.commit("setCartQuantity", this.cartQuantity);

                            let payload = {
                                type:"success",
                                message:"Item added to cart!"
                            }
                            this.open(payload)
                            // emiting event to iframe to enable view cart button
                            if (this.$refs.iframeRef && this.$refs.iframeRef.contentWindow) {
                                this.$refs.iframeRef.contentWindow.postMessage({
                                type: 'enable-viewcart-cta'
                                }, this.tgptIframeUrl);
                            }
                        })
                        .catch(error => {
                            let payload = {
                                type:"error",
                                message:"Failed to add to cart"
                            }
                            this.open(payload)
                        });
                }
            }
        },
        cutoffToPixels(cutoff) {
            const cutoffs = {
                mobile: 0,
                tablet: 769,
                desktop: 1024,
                widescreen: 1216,
                fullhd: 1408,
            };

            if (typeof cutoff === "number") {
                return cutoff;
            } else if (cutoffs[cutoff]) {
                return cutoffs[cutoff];
            } else {
                return cutoffs.desktop;
            }
        },
        fetchSessionID() {
            // this.TgptService = new TgptService();
            this.cartService.fetchSession().then(response => {
                    if(response?.sessionId) {
                        this.updateSessionId(response.sessionId)
                    }
                })
                .catch(error => {
                    console.log(error)
                });


        }
    },
    mounted() {  
        Cookies.set('skuParams','');
        this.cartService = new CartService();
        this.fetchSessionID()

        const iframeRefs = this.$refs.iframeRef

        if (iframeRefs && iframeRefs.contentWindow) {
            this.setIframeRef(iframeRefs);
            this.setIframeLoaded(true);
        }
        window.addEventListener('message', this.handleIframeMessage);
        this.checkSessionCookie()


        const params = new URLSearchParams(window.location.search);
        const isMobileQuery = params.get('isMobile');
        this.isMobileMax = false
        if (isMobileQuery === 'true' && this.isMobileLayout) {
            this.isMobileMax = true
            this.openIframe(); // Show the chat popup
            this.handleMiniseAndMaxiseEvent(false) // Ensure it’s not minimized
        }


        const bannerEl = document.getElementById('global-banner');
        if (bannerEl) {
        this.bannerHeight = bannerEl.offsetHeight;
        }

    },
    beforeDestroy() {
        window.removeEventListener('message',  this.handleIframeMessage);
    }
}
</script>
